export enum FeeFieldCondition {
  NA = "N/A",
  None = "None",
  Positive = "Positive",
  PositiveNumber = "PositiveNumber",
  SpecificValue = "SpecificValue",
}

export enum FeeCapMethodToShowTieredAdminFeature {
  FeeCapByFees = "FeeCapByFees",
  FeeCapByBalance = "FeeCapByBalance",
}